<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-input placeholder="IP地址" allowClear v-model="address" class="a_input_self margin_self" />
			<a-input placeholder="姓名" allowClear v-model="name" class="a_input_self margin_self" />
			<a-button type="primary" icon="search" style="margin: 5px" @click="serch"> 查询 </a-button>
			<a-button icon="sync" style="margin: 5px" @click="result"> 重置 </a-button>
			<!-- <a-button type="primary" @click="exp"> 导出 </a-button> -->
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="data" bordered :scroll="{ y: scroll_y }" rowKey="id" :pagination="pagination" @change="handleTableChange">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ (pagination.current-1)*10+index+1 }}</template>
				</a-table-column>
				<a-table-column key="tokenId" title="会话编号" ellipsis="true" data-index="tokenId" />
				<a-table-column key="name" title="用户名" ellipsis="true" data-index="loginName" />
				<a-table-column key="userName" title="姓名" ellipsis="true" data-index="userName" />
				<a-table-column key="deptName" title="所在部门" ellipsis="true" data-index="deptName" />
				<a-table-column key="loginTime" title="时间" ellipsis="true" data-index="loginTime" />
				<a-table-column key="ipaddr" title="IP地址" ellipsis="true" data-index="ipaddr" />
				<a-table-column key="loginLocation" title="地点" ellipsis="true" data-index="loginLocation" />
				<a-table-column key="deviceType" title="登录设备" data-index="deviceType">
					<template scope="text,record">
						<span v-if="record.deviceType=='pc'">
							PC端
						</span>
						<span v-else-if="record.deviceType=='wx'">
							移动端
						</span>
					</template>
				</a-table-column>
				<a-table-column key="browser" title="浏览器" ellipsis="true" data-index="browser" />
				<a-table-column key="name" title="操作系统" ellipsis="true" data-index="os" />
				<a-table-column key="action" title="操作" data-index="action" width="100">
					<template scope="text,record">
						<a-popconfirm title="确定要强退该用户吗？" ok-text="是" cancel-text="否" @confirm="details(record)" @cancel="cancel">
							<a>
								<a-icon type="delete" />强退</a>
						</a-popconfirm>

					</template>
				</a-table-column>
			</a-table>
		</div>
	</div>
</template>

<script>
	import {
		online_list,
		force_logout
	} from '@/api/monitor'
	export default {
		data() {
			return {
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
				},
				data: [],
				name: '',
				address: '',
				scroll_y: 150,
			}
		},
		created() {
			this.get_list()
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 50
				}, 1000)
			})
		},
		methods: {
			cancel(){
				this.$message.error('你选择了取消！');
			},
			details(row) {
				force_logout(row).then(res => {
					if(res.code==200){
						this.$message.success('删除成功！')
						this.get_list()
					}else{
						this.$message.success(res.msg)
					}
				})
			},
			//搜索
			serch() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.loading = true
				this.get_list()
			},
			result() {
				this.name = ''
				this.address = ''
			},
			get_list() {
				this.loading = true
				online_list({
					page_size: this.pagination.pageSize,
					page_num: this.pagination.current,
					userName: this.name,
					ipaddr: this.address
				}).then((res) => {
					this.loading = false
					const pagination = { ...this.pagination
					}
					pagination.total = res.total
					this.pagination = pagination
					this.data = res.rows
					this.data.forEach((item) => {
						item.price = item.price / 100
						item.value = item.value / 100
						item.amount = item.amount / 100
					})
				})
			},
		}
	}
</script>

<style>
	.dialog {
		display: flex;
		justify-content: space-between;
	}

	.flex {
		display: flex;
	}

	.center {
		text-align: center;
		width: 832px;
	}

	.dialog .dialog_item {
		margin-bottom: 5px;
		width: 220px;
		display: flex;
		justify-content: space-between;
	}

	.Exhi {
		display: inline-block;
		border: 1px solid black;
		width: 100px;
		text-align: left;
		color: steelblue;
	}
</style>
